import { baseConfig } from './base.config';
import { Config } from './config.interface';

export const stagingConfig: Config = {
  ...baseConfig,
  blockchain: {
    providers: {
      tenderly: {
        url: 'https://polygon.gateway.tenderly.co/wAiijrrN77jEvpzeZn4tF',
        wss: 'wss://polygon.gateway.tenderly.co/wAiijrrN77jEvpzeZn4tF',
      },
      quickNode: {
        url: 'https://alpha-withered-breeze.matic.quiknode.pro/99785f31e356ac1e2ec2c469b6bc61af1e23ac69',
        wss: 'wss://alpha-withered-breeze.matic.quiknode.pro/99785f31e356ac1e2ec2c469b6bc61af1e23ac69',
      },
    },
    explorerUrl: 'https://polygonscan.com',
    chainId: 137,
    usdtDecimals: 18,
    phnmDecimals: 18,
  },
  tenderly: {
    accountSlug: 'phenom_poker',
    projectSlug: 'backend-staging',
  },
  posthogPublicApiKey: 'phc_IEwnIfHTQzrc5hh8LOGIMjs1ePGNHMPlIHAwOyy2SOM',
  urls: {
    app: 'https://app.staging.phenompoker.com',
    admin: 'https://admin.staging.phenompoker.com',
    landing: 'https://phenompoker.com',
    otherCorsOrigins: [
      'https://app.feat-1.phenompoker.com',
      'https://app.feat-2.phenompoker.com',
      'https://app.feat-3.phenompoker.com',
      'https://app.feat-4.phenompoker.com',
      'https://app.feat-5.phenompoker.com',
      'https://admin.feat-1.phenompoker.com',
      'https://admin.feat-2.phenompoker.com',
      'https://admin.feat-3.phenompoker.com',
      'https://admin.feat-4.phenompoker.com',
      'https://admin.feat-5.phenompoker.com',
    ],
    desktopClientDownloadPrefix: 'https://assets.staging.phenompoker.com/desktop-client/Phenom%20Poker.staging',
  },
};
